import { StorageAreaUpdateForm } from "raft/StorageAreaForm";
import React from "react";

import { styled } from "@mui/material/styles";
import LoadingSpinner from "components/atomics/LoadingSpinner";
import Toast from "components/atomics/Toast";
import { toastStateAtom } from "components/atomics/Toast/toastState";
import L from "leaflet";
import getTestIDs from "lib/utils/getTestIDs";
import { useHistory, useParams } from "react-router-dom";
import { useRecoilState } from "recoil";
import translations from "translations";

export const testIDs = getTestIDs();

export const UpdateStorageAreaFormSC = styled("div")({
  height: "calc(100vh - 108px)",
  display: "flex",
});

const UpdateGeofence: React.FC<{}> = () => {
  const { storageAreaId }: { storageAreaId: string } = useParams();
  const [toastObject, setToastObject] = useRecoilState(toastStateAtom);
  const history = useHistory();

  const close = () => {
    try {
      setToastObject({
        open: true,
        message: translations.pages.fleetInventory.toastMessageUpdate.success,
        severity: "success",
      });
      history.push("/fleetInventory");
    } catch (error) {
      setToastObject({
        open: true,
        message: translations.pages.fleetInventory.toastMessageUpdate.error,
        severity: "error",
      });
      history.push("/fleetInventory");
    }
  };

  const handleCloseToast = () => {
    setToastObject(undefined);
  };

  return (
    <UpdateStorageAreaFormSC>
      <LoadingSpinner loading={!storageAreaId} testId={testIDs.addGeofencesLoader}>
        <div>
          <StorageAreaUpdateForm
            id={storageAreaId}
            onCancel={close}
            afterUpdate={close}
            beforeRemoteMuatation={(p) => {
              return {
                ...p.data,
              };
            }}
            onUpdateDataMiddleWare={(p) => {
              if (!p.data.storageAreaName?.length) {
                return {
                  ...p.data,
                  disableStep: 1,
                  noPolygon: 1,
                };
              }

              if (!p.data.geofence?.coordinates) {
                return {
                  ...p.data,
                  disableStep: 1,
                  noPolygonWarning: translations.pages.fleetInventory.noPolygonWarning,
                  noPolygon: 0,
                };
              }
              if (p.data.geofence) {
                const minAllowedPolygonSize = 2500; // min 50x50m = 2,500 m²
                const maxAllowedPolygonSize = 500000000; // max 500 km² = 500,000,000 m²
                const polygon = L.polygon(p.data.geofence?.coordinates);
                const polygonSize = L.GeometryUtil.geodesicArea(polygon.getLatLngs()[0] as L.LatLngLiteral[]);
                if (polygonSize < minAllowedPolygonSize) {
                  setToastObject({
                    open: true,
                    message: translations.pages.fleetInventory.smallGeofenceWarning,
                    severity: "error",
                  });
                  return {
                    ...p.data,
                    disableStep: 1,
                    noPolygonWarning: translations.pages.fleetInventory.noPolygonWarning,
                    noPolygon: 0,
                  };
                }
                if (polygonSize > maxAllowedPolygonSize) {
                  setToastObject({
                    open: true,
                    message: translations.pages.fleetInventory.largeGeofenceWarning,
                    severity: "error",
                  });
                  return {
                    ...p.data,
                    disableStep: 1,
                    noPolygonWarning: translations.pages.fleetInventory.noPolygonWarning,
                    noPolygon: 0,
                  };
                }
              }

              //@ts-ignore
              if (!!p.data.formHasErrors && p.data.submit) {
                return {
                  ...p.data,
                  //@ts-ignore
                  submit: !p.data.formHasErrors,
                };
              }
              setToastObject(undefined);
              return {
                ...p.data,
                disableStep: 0,
                noPolygonWarning: "",
                noPolygon: 1,
                formHasErrors:
                  !p.data.storageAreaTypeId || !p.data.storageAreaName || !p.data.geofence?.coordinates ? 1 : 0,
              };
            }}
          />
        </div>
      </LoadingSpinner>
      {toastObject && <Toast {...toastObject} handleCloseToast={handleCloseToast} />}
    </UpdateStorageAreaFormSC>
  );
};

export default UpdateGeofence;
